import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Label,
  Row,
  Col
} from "reactstrap";

import db from "../../firebaseConfig";

function saveContactData(email) {
  const collection = db.collection("contact");
  collection.doc(`${email.email}`).set(email);
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export default class Contact extends Component {
  state = {
    pristine: true,
    email: "",
    isEmailValid: false,
    emailSent: false
  };

  setEmail = e => {
    const email = e.target.value;
    if (email) {
      this.setState({
        pristine: false,
        isEmailValid: true,
        email: email,
        emailSent: false
      });
    } else {
      this.setState({
        pristine: true,
        isEmailValid: true,
        email: "",
        emailSent: false
      });
    }
  };

  go = e => {
    const email = document.querySelector(".email").value;
    if (validateEmail(email)) {
      saveContactData({ email: `${email}` });
      this.setState({ emailSent: true });
    } else {
      console.info("not right");
      this.setState({ isEmailValid: false });
    }
  };

  render() {
    const { pristine, email, emailSent, isEmailValid } = this.state;
    console.info({ email, isEmailValid });
    return (
      <Row className="contact--form">
        <Col className="contact--form--header" md="12" lg="12">
          <h5>Let's Talk</h5>
          <p>We Are Currently Considering New Projects</p>
        </Col>

        <Col sm="12" md="10" lg="10">
          <InputGroup>
            {pristine ? (
              <Input
                onChange={this.setEmail}
                type="email"
                className="email"
                placeholder="Your Email Address"
                name="email"
                value={email}
              />
            ) : (
              <Input
                valid={isEmailValid}
                onChange={this.setEmail}
                type="email"
                className="email"
                name="email"
                value={email}
              />
            )}
            {"  "}
            <Button
              size="md"
              className="contact--form--button"
              onClick={this.go}
              disabled={!isEmailValid}
            >
              Go <i class="fas fa-caret-right"> </i>
            </Button>
          </InputGroup>

          {!pristine &&
            !isEmailValid && (
              <Label className="invalid-email" htmlFor="email">
                Please enter your email address
              </Label>
            )}
          {emailSent && (
            <Label className="text-success" htmlFor="email">
              We will be in touch{" "}
              <span role="img" aria-label="happy face">
                😊
              </span>{" "}
            </Label>
          )}
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Contact/index.js